// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { MessageDialog } from 'speed-js-react-web';
import type { AlertDialog, ConfirmDialog } from 'esm-web-pro/redux/workflow/msgDialog';
import {
    getAlerts, getConfirms, removeAlert, removeConfirm,
} from 'esm-web-pro/redux/workflow/msgDialog';
import connectWorkflow from 'esm-web-pro/components/workflows/connectWorkflow';


type Props = {
    alerts: Array<AlertDialog>;
    confirms: Array<ConfirmDialog>;
    removeAlert: (key: string) => void,
    removeConfirm: (key: string) => void,
    resumeFlow: Function,
};


const mapStateToProps = (state) => ({
    alerts: getAlerts(state),
    confirms: getConfirms(state),
});


@connect(mapStateToProps, (dispatch) => (bindActionCreators({ removeAlert, removeConfirm }, dispatch)))
@connectWorkflow
class MessageDialogs extends React.Component<Props> {
    static defaultProps = {
        alerts: [],
        confirms: [],
        resumeFlow: () => undefined,
    };

    handleAlertDismiss = (e: SyntheticMouseEvent<HTMLButtonElement>, alert: AlertDialog) => {
        e.preventDefault();
        const { removeAlert: removeAlertAction } = this.props;
        removeAlertAction(alert.key);
    };

    handleConfirmActionClick = (e: SyntheticMouseEvent<HTMLButtonElement>, action: string, confirm: ConfirmDialog) => {
        e.preventDefault();

        const { removeConfirm: removeConfirmAction, resumeFlow } = this.props;

        resumeFlow(confirm.executionId, { [confirm.key]: action });
        removeConfirmAction(confirm.key);
    };

    renderAlert = (alert: AlertDialog) => (
        <MessageDialog
            message={alert.message}
            title={alert.title}
            actions={{
                dismiss: {
                    // TODO: i18n
                    label: alert.actionLabel || 'OK',
                    callback: (e) => this.handleAlertDismiss(e, alert),
                },
            }}
            size={alert.size}
            key={alert.key}
        />
    );

    renderConfirm = (confirm: ConfirmDialog) => {
        const actions = {};

        Object.keys(confirm.actions).forEach((name) => {
            actions[name] = {
                ...confirm.actions[name],
                callback: (e) => this.handleConfirmActionClick(e, name, confirm),
            };
        });

        return (
            <MessageDialog
                message={confirm.message}
                title={confirm.title}
                actions={actions}
                actionsAlign="end"
                key={confirm.key}
            />
        );
    };

    render() {
        const { alerts, confirms } = this.props;

        return (
            <React.Fragment>
                {alerts.map(this.renderAlert)}
                {confirms.map(this.renderConfirm)}
            </React.Fragment>
        );
    }
}

export default MessageDialogs;
